// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
// FUNCTIONS
import is_new_creative from "../../../../hooks/is_new_creative";
import { createPreviewLink } from "../functions/createPreviewLink";
// CONTEXT
import { useUserState } from "../../../../contexts/user.context";
// TYPES
import { HandlePreviewButtonProps, StudioConfig } from "../types";
// CONFIGS
import studio_config from "../../../../configs/studio.json";
import config from "../../../../configs/config";

export function PreviewButton({ isTruncated, data }: HandlePreviewButtonProps) {
  const user = useUserState();
  const isNewCreative = is_new_creative();
  const studioConfig: StudioConfig = studio_config;
  // Bring-your-own packages have no studio format entry (metadata.format is "custom"), so they can't
  // go through the frame-ratio/preview-site lookups below. Their entry file is the unpacked index.html
  // (public-read) — preview it straight from S3 in every environment.
  // Also treat an unknown format as a package so preview never indexes a missing studio format entry —
  // resilient to the row arriving before the server schema that exposes metadata.kind is redeployed.
  const isPackage = data.metadata.kind === "package" || !studioConfig.formats[data.metadata.format];
  const frameRatios = isPackage ? [] : studioConfig.formats[data.metadata.format || "post"].media.frameRatios;

  const handlePreview = (e: React.MouseEvent<Element, MouseEvent> | undefined) => {
    (e?.currentTarget as HTMLButtonElement).blur();
    if (isPackage) {
      window.open(`https://${config.s3.BUCKET}.s3.${config.s3.REGION}.amazonaws.com/public/${user.teamId}/${data.id}/index.html`);
      return;
    }
    const aspectRatio = data.metadata.aspectRatio || "picnic";
    const matchedFrameRatio = frameRatios.findIndex((frameRatio: FrameRatio) => frameRatio.name === aspectRatio);
    const configuration = {
      analytics: {
        DISABLED: config.analytics.DISABLED,
      },
      preview: {
        URL: config.preview.URL,
      },
      s3: {
        BUCKET: config.s3.BUCKET,
        REGION: config.s3.REGION,
      },
      environment: config.environment,
      adSlot: {
        adSlotWidth: studioConfig.formats[data.metadata.format].media.frameRatios[matchedFrameRatio].adSlotWidth,
        adSlotHeight: studioConfig.formats[data.metadata.format].media.frameRatios[matchedFrameRatio].adSlotHeight,
      },
    };
    const previewLink = createPreviewLink(data, user, configuration);
    window.open(previewLink);
  };

  return <>{isTruncated ? <ComponentLibrary.PCIconButton icon={"eye"} title={"Preview"} utilityClasses={"b--black-20"} inlineStyles={{ height: "40px", width: "40px" }} clickHandler={handlePreview} /> : <ComponentLibrary.PCActionButton isDisabled={isNewCreative} text={"Preview"} iconLeft={"eye"} iconColor={"color-text-5"} textColor={"color-text-5"} color={""} clickHandler={handlePreview} />}</>;
}
